"use strict";
exports.__esModule = true;
exports.mergeReferenceInto = void 0;
function mergeReferenceInto(target, referencedSchema, siblings, policy) {
    switch (policy) {
        case 'by_keyword': {
            // Reapply siblings so that referencedSchema does not override sibling properties
            Object.assign(target, referencedSchema, siblings);
            break;
        }
        case 'overwrite':
            // Ignore siblings
            Object.assign(target, referencedSchema);
            break;
        case 'none':
            // none is not valid for Draft 04 schemas, same effect as overwite
            Object.assign(target, referencedSchema);
            break;
        case 'default':
        default: {
            // default is to merge
            Object.assign(target, referencedSchema, siblings);
            break;
        }
    }
}
exports.mergeReferenceInto = mergeReferenceInto;
